import tokenProvider from '../../utils/token';

const baseUrl = process.env.REACT_APP_PORTAL_URL;


export async function fetchPost(url = '', data = {}) {
  const response = await fetch(baseUrl + url, {
    method: 'POST', 
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      "accept": "application/json, text/plain, */*",
      "accept-language": "en-GB,en-US;q=0.9,en;q=0.8,nl;q=0.7",
      "content-type": "application/json",
      "sec-fetch-dest": "empty",
      "sec-fetch-mode": "cors",
      "sec-fetch-site": "cross-site",
      "authorization": `Bearer ${tokenProvider.getToken()}`
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
  if(!response.ok) {
    return undefined;
  }
  return response.json();
}

export async function fetchGet(url = '') {
  const response = await fetch(baseUrl + url, {
    method: 'GET', 
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      "accept": "application/json, text/plain, */*",
      "accept-language": "en-GB,en-US;q=0.9,en;q=0.8,nl;q=0.7",
      "content-type": "application/json",
      "sec-fetch-dest": "empty",
      "sec-fetch-mode": "cors",
      "sec-fetch-site": "cross-site",
      "authorization": `Bearer ${tokenProvider.getToken()}`
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  });
  if(!response.ok) {
    return undefined;
  }
  return response.json();
}

export async function fetchDelete(url = '') {
  const response = await fetch(baseUrl + url, {
    method: 'DELETE', 
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      "accept": "application/json, text/plain, */*",
      "accept-language": "en-GB,en-US;q=0.9,en;q=0.8,nl;q=0.7",
      "content-type": "application/json",
      "sec-fetch-dest": "empty",
      "sec-fetch-mode": "cors",
      "sec-fetch-site": "cross-site",
      "authorization": `Bearer ${tokenProvider.getToken()}`
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  });
  return response.ok;
}

export async function fetchPatch(url='', data = {}) {
  const response = await fetch(baseUrl + url, {
    method: 'PATCH', 
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      "accept": "application/json, text/plain, */*",
      "accept-language": "en-GB,en-US;q=0.9,en;q=0.8,nl;q=0.7",
      "content-type": "application/json",
      "sec-fetch-dest": "empty",
      "sec-fetch-mode": "cors",
      "sec-fetch-site": "cross-site",
      "authorization": `Bearer ${tokenProvider.getToken()}`
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
  if(!response.ok) {
    return undefined;
  }
  return response.json();
}